import React, { Component } from 'react';
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'
import { EVENT_GET_DETAIL_BOT_LOG } from '../../configs/EventTypes'
import { ReportReceiptPDFScreen } from '../../screens'

import $ from 'jquery'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { getReportReceiptPDF, getReportReceiptPDFCommittee,genReportReceiptPdf } from '../../redux/actions/ReportAction'
import {msg} from '../../components/Notifications/MsgBox';
import AdjustmentService from '../../services/AdjustmentService'


var base64 = require('base-64')
var utf8 = require('utf8')

class ReceiptTablePage extends Component {
    constructor (props) {
        super(props)

        this.state = {
            searchResult: [],
            page: 0,
            rowsPerPage: 10,
            pdf_data: null,

        }
        this.handlerClick = this.handlerClick.bind(this)
        this.renderPDF = this.renderPDF.bind(this)
        this.exportPDF = this.exportPDF.bind(this)
        this.handlerEditClick = this.handlerEditClick.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.tablesearch !== this.state.searchResult) {

            this.setState({
                searchResult: nextProps.tablesearch,
                page: 0,
            })
        }
    }

    handleChangePage (event, newPage, pageName) {
        this.setState({
            [pageName]: newPage,
        })
    }

    handleChangeRowsPerPage (event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0,
        })
    }

    handlerClick (rowIndex, transactionNo) {

        //console.log(rowIndex)
        //console.log(transaction_no)

        const { searchResult } = this.state
        let { history } = this.props
        if (transactionNo !== '') {
            var clickRowOntask = searchResult.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {

                let bytes_tran_no = utf8.encode(clickRowOntask[0].transaction_no)
                let encoded_transaction_no = base64.encode(bytes_tran_no)

                let bytes_po_contract_no = utf8.encode(clickRowOntask[0].po_contract_no)
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no)

                history.push({
                    pathname: '/main',
                    search: `?mode=EDIT&transaction_no=${ encoded_transaction_no }&po_no=${ encoded_po_contract_no }`,
                    state: { searchResult: clickRowOntask[0], mode: 'EDIT' },
                })
            }
        }
    }

    /*setDetailBotLogModal (type, transaction_no = '') {

        window.emitter.emit(EVENT_GET_DETAIL_BOT_LOG, {
            transaction_no: transaction_no,
        })

        window.$('#DetailBotLogModal').modal('show')
    }*/

    handlerEditClick(rowIndex, transactionNo,doc_type,pO_CONTRACT_NO) {

        let { history, tasks } = this.props;

        if (transactionNo !== '') {

            let bytes_tran_no = utf8.encode(transactionNo);
            let encoded_transaction_no = base64.encode(bytes_tran_no);

            let bytes_po_contract_no = utf8.encode(pO_CONTRACT_NO);
            let encoded_po_contract_no = base64.encode(bytes_po_contract_no);
            if (doc_type == "BOT"){
                history.push({
                    pathname: '/main',
                    search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                    state: { mode: 'EDIT' }
                });
            }else{
                history.push({
                    pathname: '/mainnotbot',
                    search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                    state: { mode: 'EDIT' }
                });

            }
            //}
        }
    }

    async renderPDF () {

        var HTML_Width = $('#page-pdf').width()
        var HTML_Height = $('#page-pdf').height()
        var top_left_margin = 25
        var PDF_Width = HTML_Width + (top_left_margin * 1.5)
        var PDF_Height = (PDF_Width) + (top_left_margin * 2.5)
        var canvas_image_width = HTML_Width
        var canvas_image_height = HTML_Height

        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1
        if (totalPDFPages === 0) {
            totalPDFPages = 1
        }
        console.log('HTML_Height:' + HTML_Height)
        console.log('PDF_Height:' + PDF_Height)

        html2canvas($('#page-pdf')[0], {
            allowTaint: false,
            letterRendering: false,
            onclone: function (clonedDoc) {
                clonedDoc.getElementById('page-pdf').style.display = 'block'
            },
        }).then(function (canvas) {

            canvas.getContext('a4')
            console.log(canvas.height + '  ' + canvas.width)
            var imgData = canvas.toDataURL('image/jpeg', 1)
            var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
            pdf.addImage(imgData, 'PNG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)

            // for (var i = 1; i <= totalPDFPages; i++) {
            //     pdf.addPage(PDF_Width, PDF_Height);
            //     pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
            // }
            window.open( pdf.output('bloburl'),'_blank')
            // pdf.output("dataurlnewwindow")
            // pdf.save("html2pdf.pdf");
            // window.open(URL.createObjectURL(blob));
        })

    }

    async exportPDF (transaction_no) {
        // $('head').append('<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>')
        // await this.props.getReceiptPDFCommittee(transaction_no)
        // await this.props.getReceiptPDF(transaction_no)
        // await this.renderPDF()

        console.log('exportPDF transaction_no', transaction_no)

        await this.props.genReportReceiptPdf(transaction_no)
        if (this.props.resultExport.isSuccess == true)
         {
            AdjustmentService.getPDFLink({url:(this.props.resultExport.returnMessage).replace('http://','https://'),filename: this.props.resultExport.docementType})
            //window.open( this.props.resultExport.returnMessage, '_blank', '');
         }
         else 
         {
            msg.error("ไม่พบข้อมูล");
         }
    }

    render () {

        const { searchResult, page, rowsPerPage } = this.state
        console.log("searchResult : ",searchResult)
        return (
            <Paper style={ { display: 'flex', flex: '1' } }>
                <div className="row no-gutters sp-table-content ">
                    <Table className="sp-table table rrs-table">
                        <TableHead>
                            <TableRow className="sp-table-header">
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>PO
                                    No.</TableCell>
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>MOM Doc
                                    No.</TableCell>
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>RRS Doc
                                    No.</TableCell>
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>Header
                                    Text</TableCell>
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>Create
                                    By</TableCell>
                                <TableCell className="th-table text-center" style={ { width: '50px' } }>Create
                                    Date</TableCell>
                                <TableCell className="th-table text-center"
                                           style={ { width: '50px' } }>Status</TableCell>
                                <TableCell className="th-table text-center"
                                           style={ { width: '50px' } }>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                searchResult ? (
                                    searchResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((task, index) => {
                                            return (
                                                <TableRow key={ index }>
                                                    <TableCell className="text-center">{ task.pO_CONTRACT_NO }</TableCell>
                                                    <TableCell className="text-center">{ task.moM_DOC_NO }</TableCell>
                                                    <TableCell className="text-center">{ task.rrS_DOC_NO }</TableCell>
                                                    <TableCell className="text-left">{ task.headeR_TEXT }</TableCell>
                                                    <TableCell className="text-left">{ task.creatE_BY }</TableCell>
                                                    <TableCell className="text-left">{ task.creatE_DATE }</TableCell>
                                                    <TableCell className="text-left">{ task.statuS_TEXT }</TableCell>
                                                    <TableCell className="text-center" style={{display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
                                                        <a onClick={() => this.handlerEditClick(index, task.transactioN_NO, task.doC_TYPE, task.pO_CONTRACT_NO) }
                                                           style={ { cursor: 'pointer',} } >
                                                            <i className="icon icon-preview-eye-blue"/>
                                                        </a>

                                                        <a onClick={ () => this.exportPDF(task) }
                                                           style={ { cursor: 'pointer', marginLeft: 10 } }>
                                                            <i className="icon icon-preview-pdf"/>
                                                        </a>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })) : (
                                    <TableRow key={ 0 }>
                                        <TableCell colSpan="11" className="text-center" style={ {
                                            textAlign: 'center',
                                            fontStyle: 'italic',
                                            color: 'gray',
                                        } }>No data</TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={ [10, 25, 50, 100] }
                        component="div"
                        count={ searchResult.length }
                        rowsPerPage={ this.state.rowsPerPage }
                        page={ this.state.page }
                        backIconButtonProps={ {
                            'aria-label': 'previous page',
                        } }
                        nextIconButtonProps={ {
                            'aria-label': 'next page',
                        } }
                        onChangePage={ (event, newPage) => this.handleChangePage(event, newPage, 'page') }
                        onChangeRowsPerPage={ (event) => this.handleChangeRowsPerPage(event, 'page', 'rowsPerPage') }
                    />
                </div>

                <div style={ { display: 'none' } } id="page-pdf" >
                    {this.props.resultPDF!=null?<ReportReceiptPDFScreen resultPDF={ this.props.resultPDF } resultPDFCommittee={ this.props.resultPDFCommittee }/>:''}
                </div>

            </Paper>
        )

    }

}

const mapStateToProps = state => {
    const { SearchRedux } = state
    return {
        resultPDF: SearchRedux.resultPDF,
        resultPDFCommittee: SearchRedux.resultPDFCommittee,
        resultExport:SearchRedux.resultExport,
    }
}

const mapDispatchToProps = dispatch => {

    return {
        getReceiptPDF: (transaction_no) => dispatch(getReportReceiptPDF(transaction_no)),
        getReceiptPDFCommittee: (transaction_no) => dispatch(getReportReceiptPDFCommittee(transaction_no)),
        genReportReceiptPdf:(transaction_no)=>dispatch(genReportReceiptPdf(transaction_no)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ReceiptTablePage)
// export default ReceiptTablePage